<script setup lang="ts">
import { onUnmounted, ref, watch } from 'vue';
import type { Rive, RiveParameters } from '@rive-app/canvas-lite';
import type { Props } from './types';

let rive: typeof import('@rive-app/canvas-lite');

const props = withDefaults(defineProps<Props>(), {
	autoplay: true,
});

const el = ref<HTMLCanvasElement>();

const topRive = {
	riveInstance: undefined as Rive | undefined,
};

watch([el, props], async () => {
	if (!rive) rive = await import('@rive-app/canvas-lite');

	const canvas = el.value;
	if (!canvas) return;

	topRive.riveInstance?.cleanup();

	const options: RiveParameters = {
		...props,
		canvas,
		onLoad: (e) => {
			props.onLoad?.(e);

			topRive.riveInstance?.resizeDrawingSurfaceToCanvas();
		},
	};

	topRive.riveInstance = new rive.Rive(options);
});

onUnmounted(() => {
	topRive.riveInstance?.cleanup();
});

defineExpose(topRive);
</script>

<template>
	<canvas ref="el" class="top-rive"></canvas>
</template>

<style>
.top-rive {
	width: 100%;
	height: 100%;
	flex-grow: 1;
}
</style>
